<template>
  <a
    :href="link"
    :class="['notifications-item', read ? 'read' : '']"
    @click.prevent="notificationItemClicked"
  >
    <img
      v-if="thumbnailUrl"
      :src="thumbnailUrl"
      :alt="title"
      class="notifications-item__thumbnail"
    >
    <div class="notifications-item__blurb">
      <span class="notifications-item__title">
        {{ title }}
      </span>
      <p class="notifications-item__body">
        {{ body }}
      </p>
      <span class="notifications-item__date">
        {{ timeMessage }}
      </span>
    </div>
  </a>
</template>

<script>
import { defineComponent } from 'vue';
import dayjs from 'dayjs';
import dayjsRelativeTimePlugin from 'dayjs/plugin/relativeTime';

dayjs.extend(dayjsRelativeTimePlugin);

export default defineComponent({
  name: 'AcvNotificationsItem',
  props: {
    id: {
      type: Number,
      required: true,
    },
    body: {
      type: String,
      required: true,
    },
    created: {
      type: Number,
      default: null,
    },
    link: {
      type: String,
      default: '',
    },
    read: {
      type: Boolean,
      default: false,
    },
    thumbnailUrl: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      required: true,
    },
    goToAuctionOnNotificationClick: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['notificationClicked'],
  computed: {
    timeMessage() {
      return dayjs(this.created * 1000).fromNow();
    },
  },
  methods: {
    notificationItemClicked($event) {
      const auctionId = Number.parseInt(this.link.replace('/auction/', ''), 10);
      this.$emit('notificationClicked', {
        $event, auctionId, notificationId: this.id, link: this.link,
      });
    },
  },
});
</script>

<style scoped lang="scss">
.notifications-item {
  display: block;
  width: 100%;
  line-height: 19.5px;
  letter-spacing: normal;
  font-weight: theme('fontWeight.regular');
  border-bottom: solid 1px rgb(0 0 0 / 10%);
  padding: 12.5px 15px;
  background: #fafafa;

  &:last-child {
    border: none;
  }

  &.read {
    background: white;
  }

  &:hover {
    background: #f3f3f3;
  }

  &:focus {
    outline: none;
  }

  &__blurb {
    position: relative;
    top: -3px;
    display: inline-block;
    width: calc(100% - 75px);
    margin-left: 13.5px;
    vertical-align: top;
  }

  &__body {
    white-space: normal;
    margin-bottom: -1px;
    font-size: 13px;
    line-height: 19.5px;
    color: rgb(0 0 0 / 60%);
  }

  &__date {
    font-size: 11px;
    color: rgb(0 0 0 / 45%);
    font-weight: 300;
  }

  &__title {
    font-weight: bold;
    color: rgb(0 0 0 / 67%);
    font-size: 13px;
  }

  &__thumbnail {
    width: 55px;
    height: 55px;
    display: inline-block;
    vertical-align: top;

    @include constants.border-radius(2px);
  }
}
</style>
